import { createAsyncThunk } from '@reduxjs/toolkit';
import { putCreateOrUpdateUser } from '../services/putCreateOrUpdateUser.service';

// Creates an avatar — a user for someone who has not registered yet — and
// joins it to the project, for the project invite. The same endpoint as
// createOrUpdateUser, without that thunk's hand-offs to the record dialog and
// the orientation flow, which an invite has no part in.
export const createAvatar = createAsyncThunk(
  'user/createAvatar',
  async (
    { userAttributes, projectKeyOfProjectToJoin, businessIdOfEmployerToJoinWith },
    { rejectWithValue }
  ) => {
    try {
      const { resource, employer } = await putCreateOrUpdateUser(
        userAttributes,
        projectKeyOfProjectToJoin,
        businessIdOfEmployerToJoinWith
      );
      return { resource, employer };
    } catch (e) {
      // A string code from ctx.throw, or { errorCode, suggestedUser } when the
      // person already exists.
      return rejectWithValue(e.response?.data);
    }
  }
);
